import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/pro-regular-svg-icons";

import { MarkerPart } from "./";

export class NoneBorder extends MarkerPart {
  protected get borderClassName(): string {
    return 'marker-border';
  }

  Content({ id, extraProps }: { id: string, extraProps: Record<string, string> }) {
    return (
      <style {...extraProps}>
        {`#marker-${id} .${this.borderClassName} {
          stroke: none;
        }`}
      </style>
    );
  }

  Thumbnail() {
    return (
      <FontAwesomeIcon icon={faBan} />
    );
  }

  title = 'None';
}

